/* eslint-disable react/no-array-index-key */
/* eslint-disable max-len */
/* eslint-disable object-curly-newline */
/* eslint-disable object-property-newline */
/* eslint-disable react/prop-types */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/no-extraneous-dependencies */

import React, {
  useEffect, useMemo, useContext, useState,
} from 'react';
import PropTypes from 'prop-types';
import { useLocation, useHistory } from 'react-router-dom';
import {
  Compass, Users, Layers, BarChart3, KeyRound, UserCog, Table, Sliders, Eye, Mail,
  Clock, Camera, ShieldAlert, MapPin, CalendarOff, Lightbulb, Info, AlertTriangle,
  ChevronRight, PlayCircle, CheckCircle2,
  Bot, Activity as ActivityIcon, Video, Laptop, FileSignature, Gauge, Keyboard, BellRing,
} from 'lucide-react';
import NavigationLayout from '../../components/NavigationLayout';
import { UserContext } from '../../contexts/User';
import {
  isTourEligible, getAccessibleTracks, TOUR_START_EVENT, WELCOME_TOUR_ID,
} from '../../components/GuidedTour/steps';
import { getTourState } from '../../components/GuidedTour/tourApi';
import ARTICLES, { ACTIVITY_TYPES } from './content';

const ICONS = {
  Compass, Users, Layers, BarChart3, KeyRound, UserCog, Table, Sliders, Eye, Mail,
  Clock, Camera, ShieldAlert, MapPin, CalendarOff,
  Bot, Activity: ActivityIcon, Video, Laptop, FileSignature, Gauge, Keyboard, BellRing,
};

const CARD = 'rounded-xl bg-white border border-surface-2 shadow-[0_1px_2px_rgba(14,30,64,0.04)]';

function Icon({ name, ...props }) {
  const Cmp = ICONS[name] || Info;
  return <Cmp {...props} />;
}
Icon.propTypes = { name: PropTypes.string.isRequired };

// Launcher row for a guided tour / feature track, with a completion tick.
function TourButton({
  label, icon, done, onClick,
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="w-full flex items-center gap-2.5 px-2.5 py-2 rounded-[8px] text-sm font-medium text-ink-700 hover:bg-surface-page transition"
    >
      <Icon name={icon} size={16} className="text-brand-700" />
      <span className="flex-1 text-left">{label}</span>
      {done
        ? <CheckCircle2 size={15} className="text-[#53A551]" />
        : <PlayCircle size={15} className="text-ink-500" />}
    </button>
  );
}
TourButton.propTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  done: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

// ── block renderers ──────────────────────────────────────────────────────
function Heading({ text }) {
  return <h2 className="text-lg font-semibold text-ink-900 mt-2 mb-1">{text}</h2>;
}
Heading.propTypes = { text: PropTypes.string.isRequired };

function Para({ text }) {
  return <p className="text-sm text-ink-700 leading-6 m-0">{text}</p>;
}
Para.propTypes = { text: PropTypes.string.isRequired };

function Bullets({ items }) {
  return (
    <ul className="m-0 pl-0 list-none space-y-2">
      {items.map((it, i) => (
        <li key={i} className="flex gap-2.5 text-sm text-ink-700 leading-6">
          <span className="mt-2 w-1.5 h-1.5 rounded-full bg-brand-500 flex-shrink-0" />
          <span>{it}</span>
        </li>
      ))}
    </ul>
  );
}
Bullets.propTypes = { items: PropTypes.arrayOf(PropTypes.string).isRequired };

function Steps({ items }) {
  return (
    <ol className="m-0 pl-0 list-none space-y-3">
      {items.map(([title, body], i) => (
        <li key={i} className="flex gap-3">
          <span
            className="flex-shrink-0 w-7 h-7 rounded-full bg-brand-700 text-white text-sm font-semibold flex items-center justify-center"
            style={{ lineHeight: 1 }}
          >
            {i + 1}
          </span>
          <div className="min-w-0 pt-0.5">
            <span className="block text-sm font-semibold text-ink-900">{title}</span>
            <span className="block text-sm text-ink-500 leading-6">{body}</span>
          </div>
        </li>
      ))}
    </ol>
  );
}
Steps.propTypes = { items: PropTypes.arrayOf(PropTypes.array).isRequired };

const CALLOUT_TONES = {
  tip: { bg: '#eef5ea', accent: '#53A551', icon: Lightbulb },
  info: { bg: '#e8eef7', accent: '#3d5a8a', icon: Info },
  warn: { bg: '#fde6d2', accent: '#CC4525', icon: AlertTriangle },
};

function Callout({
  tone, title, text,
}) {
  const t = CALLOUT_TONES[tone] || CALLOUT_TONES.info;
  const CIcon = t.icon;
  return (
    <div className="rounded-xl p-4 flex gap-3" style={{ background: t.bg }}>
      <span
        className="flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center bg-white"
        style={{ color: t.accent }}
      >
        <CIcon size={16} />
      </span>
      <div className="min-w-0">
        <span className="block text-sm font-semibold" style={{ color: t.accent }}>{title}</span>
        <span className="block text-sm text-ink-700 leading-6 mt-0.5">{text}</span>
      </div>
    </div>
  );
}
Callout.propTypes = {
  tone: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

function DocTable({ head, rows }) {
  return (
    <div className={`${CARD} overflow-hidden`}>
      <table className="w-full border-collapse">
        <thead>
          <tr className="bg-surface-page text-left">
            {head.map((h, i) => (
              <th
                key={i}
                className="text-[11px] font-semibold uppercase tracking-wider text-ink-500 px-4 py-2.5"
                style={{ letterSpacing: '0.05em' }}
              >
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((r, ri) => (
            <tr key={ri} className="border-t border-surface-1">
              {r.map((c, ci) => (
                <td
                  key={ci}
                  className={`px-4 py-2.5 text-sm align-top ${ci === 0 ? 'font-medium text-ink-900 whitespace-nowrap' : 'text-ink-700'}`}
                >
                  {c}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
DocTable.propTypes = {
  head: PropTypes.arrayOf(PropTypes.string).isRequired,
  rows: PropTypes.arrayOf(PropTypes.array).isRequired,
};

function FeatureCards({ items }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
      {items.map(([icon, title, text], i) => (
        <div key={i} className={`${CARD} p-4`}>
          <span className="w-9 h-9 rounded-full flex items-center justify-center bg-surface-1 text-brand-700 mb-2.5">
            <Icon name={icon} size={18} />
          </span>
          <span className="block text-sm font-semibold text-ink-900 mb-1">{title}</span>
          <span className="block text-sm text-ink-500 leading-6">{text}</span>
        </div>
      ))}
    </div>
  );
}
FeatureCards.propTypes = { items: PropTypes.arrayOf(PropTypes.array).isRequired };

function Activities() {
  return (
    <div className={`${CARD} overflow-hidden`}>
      {ACTIVITY_TYPES.map((a, i) => (
        <div key={a.letter} className={`flex items-center gap-3 px-4 py-3 ${i > 0 ? 'border-t border-surface-1' : ''}`}>
          <span
            className="flex-shrink-0 w-8 h-8 rounded-full text-white text-sm font-semibold flex items-center justify-center"
            style={{ background: a.color }}
          >
            {a.letter}
          </span>
          <div className="min-w-0 flex-1">
            <span className="block text-sm font-semibold text-ink-900">{a.name}</span>
            <span className="block text-sm text-ink-500 leading-5">{a.desc}</span>
          </div>
          <span
            className="flex-shrink-0 inline-flex items-center px-2.5 py-1 rounded-full text-[11px] font-semibold"
            style={a.scored ? { background: '#eef5ea', color: '#53A551' } : { background: '#f1f2f5', color: '#546077' }}
          >
            {a.scored ? 'Counts to score' : 'Not scored'}
          </span>
        </div>
      ))}
    </div>
  );
}

function Block({ block }) {
  switch (block.t) {
    case 'h': return <Heading text={block.text} />;
    case 'p': return <Para text={block.text} />;
    case 'bullets': return <Bullets items={block.items} />;
    case 'steps': return <Steps items={block.items} />;
    case 'callout': return <Callout tone={block.tone} title={block.title} text={block.text} />;
    case 'table': return <DocTable head={block.head} rows={block.rows} />;
    case 'cards': return <FeatureCards items={block.items} />;
    case 'activities': return <Activities />;
    default: return null;
  }
}
Block.propTypes = { block: PropTypes.shape({ t: PropTypes.string.isRequired }).isRequired };

// ── screen ───────────────────────────────────────────────────────────────
function Help() {
  const location = useLocation();
  const history = useHistory();
  const { member, activeWorkspace } = useContext(UserContext);
  const tourEligible = isTourEligible(member);
  const tracks = useMemo(() => getAccessibleTracks(member), [member]);
  const topic = new URLSearchParams(location.search).get('topic');

  // Per-member tour state, so each track can show a completion tick. Refetched on
  // mount — running a track navigates away, so returning to Help reflects the tick.
  const [tourState, setTourState] = useState({ tourStatus: 'pending', tourProgress: {} });
  useEffect(() => {
    if (!tourEligible || !activeWorkspace?.id) return undefined;
    let cancelled = false;
    getTourState(activeWorkspace.id)
      .then((s) => { if (!cancelled && s) setTourState(s); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [tourEligible, activeWorkspace?.id]);

  const startTour = (tour) => window.dispatchEvent(
    new CustomEvent(TOUR_START_EVENT, { detail: { tour } }),
  );

  const active = useMemo(
    () => ARTICLES.find((a) => a.id === topic) || ARTICLES[0],
    [topic],
  );

  // Keep the URL canonical (and shareable) when landing without a topic.
  useEffect(() => {
    if (!topic) history.replace(`/help?topic=${ARTICLES[0].id}`);
  }, [topic, history]);

  const selectArticle = (id) => {
    history.push(`/help?topic=${id}`);
    const scroller = document.querySelector('.screen-wrapper');
    if (scroller) scroller.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <NavigationLayout
      title="Help & Documentation"
      subtitle="Guides for managing users, teams and reporting in your Shoot workspace"
    >
      <div className="mt-4 grid grid-cols-1 lg:grid-cols-[248px_minmax(0,1fr)] gap-5 items-start" style={{ fontFamily: 'Inter, sans-serif' }}>
        {/* Article navigation */}
        <nav className={`${CARD} p-2 lg:sticky`} style={{ top: 16 }} aria-label="Documentation topics">
          <p className="text-[11px] font-semibold uppercase tracking-wider text-ink-500 px-2 pt-1.5 pb-1" style={{ letterSpacing: '0.05em' }}>
            Topics
          </p>
          <ul className="m-0 p-0 list-none">
            {ARTICLES.map((a) => {
              const isActive = a.id === active.id;
              return (
                <li key={a.id}>
                  <button
                    type="button"
                    onClick={() => selectArticle(a.id)}
                    aria-current={isActive ? 'page' : undefined}
                    className={`w-full flex items-center gap-2.5 px-2.5 py-2 rounded-[8px] text-sm text-left transition ${
                      isActive ? 'bg-surface-1 text-ink-900 font-semibold' : 'text-ink-700 font-medium hover:bg-surface-page'
                    }`}
                  >
                    <Icon name={a.icon} size={16} className={isActive ? 'text-brand-700' : 'text-ink-500'} />
                    <span className="flex-1 truncate">{a.label}</span>
                    {isActive && <ChevronRight size={14} className="text-ink-500" />}
                  </button>
                </li>
              );
            })}
          </ul>
          {tourEligible && (
            <div className="mt-1.5 border-t border-surface-1 pt-1.5" style={{ borderTopStyle: 'solid' }}>
              <p className="text-[11px] font-semibold uppercase tracking-wider text-ink-500 px-2 pt-1 pb-1" style={{ letterSpacing: '0.05em' }}>
                Product tours
              </p>
              <TourButton
                label="Take the product tour"
                icon="Compass"
                done={tourState.tourStatus !== 'pending'}
                onClick={() => startTour(WELCOME_TOUR_ID)}
              />
              {tracks.map((t) => (
                <TourButton
                  key={t.id}
                  label={t.label}
                  icon={t.icon}
                  done={tourState.tourProgress?.[t.id] === 'completed'}
                  onClick={() => startTour(t.id)}
                />
              ))}
            </div>
          )}
        </nav>

        {/* Article body */}
        <article className="min-w-0 space-y-5 pb-10">
          <header className={`${CARD} p-5`}>
            <div className="flex items-center gap-3 mb-2">
              <span className="w-11 h-11 rounded-xl flex items-center justify-center bg-brand-700 text-white flex-shrink-0">
                <Icon name={active.icon} size={20} />
              </span>
              <h1 className="text-2xl font-bold text-ink-900 m-0 leading-tight">{active.title}</h1>
            </div>
            <p className="text-sm text-ink-500 leading-6 m-0">{active.lead}</p>
            {active.where && (
              <span className="inline-flex items-center gap-1.5 mt-3 px-3 py-1.5 rounded-full text-xs font-semibold bg-surface-1 text-brand-700">
                <Compass size={13} />
                {active.where}
              </span>
            )}
          </header>

          <div className="space-y-4">
            {active.blocks.map((block, i) => (
              <Block key={i} block={block} />
            ))}
          </div>
        </article>
      </div>
    </NavigationLayout>
  );
}

export default Help;
